<template>
  <v-card flat color="grey lighten-5">
    <v-layout row wrap>
      <v-toolbar class="baslik" size="120px" dark color="info">
        <v-toolbar-title class="baslikfont"> {{ $t('Restaurant-List') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field v-if="CardView" :label="this.$t('Search-(minumum-3-characters)')"  flat="" solo-inverted="" hide-details append-icon="search"
          v-model="Query.q"></v-text-field>
           <v-text-field v-if="ListView" :label="this.$t('Search')"  flat="" solo-inverted="" hide-details append-icon="search"
          v-model="Query.q"></v-text-field>
        &nbsp;
<v-flex shrink>
    <v-btn
      icon
      color=""
      @click="clearSearch"
      :disabled="!Query.q"
    >
      <v-icon>clear</v-icon>
    </v-btn>
  </v-flex>
        &nbsp;

        <a target="_self" v-bind:href="'#/coper/saticilar/islem/id?isl=yeni&tip=3'">
          <v-btn flat> <span class="hidden-sm-and-down">{{ $t('Add-Restaurant') }}  </span>
            <v-icon right dark>add_box</v-icon>
          </v-btn>
        </a>
        <v-menu offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>

          <v-list>

            <v-list-tile @click="saticiExcel()">
              <v-list-tile-title>{{$t('all_records_excel')}}</v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>
      </v-toolbar>
      <v-container fluid>
  <v-layout row align-center>
   
    <v-flex shrink>
      <v-btn @click="KartGorunumu()"  :color="CardView ? 'primary' : 'grey'"
    :outline="!CardView"
    dark> <v-icon left>view_module</v-icon> {{$t("Card-View")}}</v-btn>
      <v-btn @click="ListeGorunumu()" :color="ListView ? 'primary' : 'grey'"
    :outline="!ListView"
    dark><v-icon left>view_list</v-icon> {{$t("List-View")}}</v-btn>
    </v-flex>

   
    <v-spacer></v-spacer>

    
    <v-flex shrink class="text-xs-right">
      <v-alert
        :value="true"
        color="white"
        icon="info"
        class="ma-0 pa-2"
      >
        <span class="subheading grey--text">
          {{ toplamkayit }}
        </span>
      </v-alert>
    </v-flex>
  </v-layout>

  
  <v-divider class="mt-2"></v-divider>
</v-container>
<v-layout row wrap>
  <v-container fluid="">
  <v-card flat v-if="ListView">

            <v-data-table :headers="headers" :loading="progress" :rows-per-page-items=[50,100,250,500,1000] :items="itemsOtel"
                :search="search" id="datatable">
                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <tr @click="goDetail(props.item)" item>
                        <td class="text-xs-left">{{ props.item.Kod }}</td>
                        <td class="text-xs-left">{{ props.item.Isim }}</td>
                        <td class="text-xs-left">{{ props.item.Ulke }}</td>
                        <td class="text-xs-left">{{ props.item.Sehir }}</td>
                        <td class="text-xs-left">{{ props.item.Tel1 }}</td>
                    </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                     {{ $t('No-records-searched-for', { value: search}) }}
                </v-alert>
            </v-data-table>
        </v-card>
  </v-container>
</v-layout>
      <v-layout row wrap v-if="CardView">
        <v-container fluid="">
          <v-layout row="" wrap="">
          


            <v-flex pa-1 xs12 sm6 md4 v-for="item in itemsOtel" v-bind:key="item.index">
              <v-hover>
                <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto"
                  width="100%">

                  <a target="_blank" v-bind:href="'#/coper/saticilar/goster/id?kod='+item.Kod+'&tip='+item.SaticiTipi">
                    <v-card flat="" class="grey--text">
                      <v-layout>
                        <v-flex xs3>
                          <img height="95%" width="95%" style=" padding-left:10%; padding-top:10%;"
                            src="../../../../assets/images/restaurant.png">
                          <!-- <img v-show="item.MusteriTipi!='K'" height="95%" width="95%"
                            style=" padding-left:15%; padding-top:15%;" src="../../../../assets/images/person.png"> -->
                        </v-flex>
                        <v-flex xs9>
                          <v-card-title primary-title>

                            <v-list-tile-title>
                              <span class="title font-weight-bold">
                                {{item.Isim}}
                              </span>
                            </v-list-tile-title>
                            <v-list-tile-title>
                              <span class="body-1 grey--text font-weight-">
                                {{item.Kod}}
                              </span>
                            </v-list-tile-title>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-flex xs12 sm12>
                        <v-list>
                          <v-list-tile>
                            <v-list-tile-action>
                              <v-icon color="grey">phone</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title> <span class="body-1 font-weight-light"> {{item.Tel1}}</span>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider inset></v-divider>
                          <v-list-tile>
                            <v-list-tile-action>
                              <v-icon color="grey">location_on</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                <span class="body-1 font-weight-light"> {{item.Sehir}}-{{item.Adres}}</span>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-card>
                  </a>
                </v-card>
              </v-hover>
            </v-flex>


          </v-layout>
        </v-container>


        <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
          <v-card color="grey lighten-5">

            <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>

              <v-layout row="" wrap="">
                <div class="flex md12">
                  <v-autocomplete hide-details clearable="" v-model="Current.Filters.BaslangicCari"
                    :label="$t('Select-Starting-Current')" append-icon="search" autocomplete :loading="loadingcaribas"
                    :items="statecaribas" item-text="text" cache-items="" item-value="id"
                    :search-input.sync="searchcaribas">
                  </v-autocomplete>

                  <v-autocomplete hide-details clearable="" v-model="Current.Filters.BitisCari" :label="$t('Select-Ending-Current')"
                    append-icon="search" autocomplete :loading="loadingcaribit" :items="statecaribit" item-text="text"
                    cache-items="" item-value="id" :search-input.sync="searchcaribit">
                  </v-autocomplete>

                  <v-autocomplete hide-details clearable="" v-model="Current.Filters.AnaHeseap  " :label="$t('Main-Account')"
                    append-icon="search" autocomplete :loading="loadingcariana" :items="statecariana" item-text="text"
                    cache-items="" item-value="id" :search-input.sync="searchcariana">
                  </v-autocomplete>

                  <v-autocomplete hide-details clearable :items="hesapgurubu" v-model="Current.Filters.HesapGrubu"
                    :label="$t('Account-Group')" multiple item-text="Title" item-value="Kod">
                    <template slot="selection" slot-scope="{ item, index }">
                      <v-chip v-if="index === 0">
                        <h4> <span>{{ item.Kod }}</span> </h4>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">(+{{
                                 Current.Filters.HesapGrubu.length - 1 }} {{ $t('other-record') }})</span>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete hide-details clearable v-model="Current.Filters.AnalizKodu" :items="analiz"
                    :label="$t('Analysis-Code')" item-text="AnalizAdi" item-value="AnalizKod" max-height="400">
                  </v-autocomplete>

                  <v-autocomplete hide-details :items="masrafmerkezi" clearable v-model="Current.Filters.Masraf"
                    :label="$t('Expense-Center-v2')" item-text="Title" item-value="Code">
                  </v-autocomplete>

                  <v-select hide-details v-model="Current.Filters.CariTip" :items="musteritipi" :label="$t('Current-Type')"
                    item-text="text" item-value="value">
                  </v-select>

                  <div class="flex md12">
                    <v-checkbox :label="$t('Account-Group-Empty-Ones')" v-model="Current.Filters.HesapGrupBos" hide-details="">
                    </v-checkbox>
                    <v-checkbox :label="$t('Accounting-Code-Empty-Ones')" v-model="Current.Filters.MuhKodBos" hide-details="">
                    </v-checkbox>
                    <v-checkbox :label="$t('External-Transfer-Code-Empty-Ones')" v-model="Current.Filters.DisAktarimBos"
                      hide-details=""></v-checkbox>
                    <v-checkbox :label="$t('Ones-with-Expense-Centre-Explanation')" v-model="Current.Filters.MasrafMerkeziTanimli"
                      hide-details=""></v-checkbox>
                    <v-checkbox :label="$t('All-Companies')" v-model="tumsirketler" hide-details=""></v-checkbox>

                  </div>

                </div>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="filtreiptal()">{{$t("cancel_button")}}</v-btn>
              <v-btn color="blue darken-1" flat @click="getOtels(Query.q)">{{ $t('Apply-Filters') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


      </v-layout>
      <yetkidialog ref="yetkidialog"></yetkidialog>
      <loadingcomp v-model="denemestatus"></loadingcomp>

      <template>

        <template>
          <v-card>
            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
              :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
              v-model="snackbar">
              {{ text1 }}
              <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>
          </v-card>
        </template>
      </template>
    </v-layout>
  </v-card>


</template>
<script>
  import imageler from '../../../../assets/images/arkman.png'
  import auth from '../../../../api/auth'
  import tool from "../../coper/tools";
  import loadingcomp from "@/components/app/customcomp/loadingcomp"

  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  export default {
    data() {
      return {
listitems:[],
         progress: true,
        
                headers: [{
                        text: this.$t('Currentcode_label'),
                        value: 'Kod'
                    },
                    {
                        text: this.$t('Title_label'),
                        value: 'Isim'
                    },
                      {
                        text: this.$t('Country'),
                        value: 'Ulke'
                    },
                      {
                        text: this.$t('City'),
                        value: 'Sehir'
                    },
                    {
                        text: this.$t('Phonenumber_label') + '1',
                        value: 'Tel1'
                    },
                  
                ],
        ListView:false,
        CardView:true,
        tumsirketler: null,
        loadingcaribas: false,
        statecaribas: [],
        searchcaribas: null,
        loadingcaribit: false,
        statecaribit: [],
        searchcaribit: null,
        loadingcariana: false,
        statecariana: [],
        searchcariana: null,
        Otel: {
          saticiTipi: 1,
          saticiKodu: null,
          sqlLike: null,
          limit: null
        },

        Current: {
          c: null,
          q: null,
          Filters: {
            BaslangicCari: null,
            BitisCari: null,
            AnaHeseap: null,
            HesapGrubu: [],
            AnalizKodu: null,
            Masraf: null,
            CariTip: '0', //0:hepsi, 1 : bireysel, 2 : Kurumsal
            HesapGrupBos: false,
            MuhKodBos: false,
            DisAktarimBos: false,
            MasrafMerkeziTanimli: false
          }
        },

        denemestatus: false,
        searchcari: null,
        analiz: [],
        masrafmerkezi: [],
        hesapgurubu: [],
        statecari: [],
        musteritipi: [{
          text: this.$t('Individual'),
          value: 'B'
        }, {
          text: this.$t('Corporate'),
          value: 'K'
        }],
        dialogfiltre: false,
        tooltip: false,
        el: null,
        loading: false,
        items: [],
        search: null,
        kayitvarmi: false,
        itemsOtel: [],
        progress: false,
        progress1: true,

        kayit: false,
        toplamkayit: this.$t('Record-Not-Listed...'),
        kayitlar: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        Query: {
          q: '',
          c: ''
        }
      }
    },
    components: {
      loadingcomp,
      yetkidialog
    },
    watch: {
      'Query.q': getOtels,
      //'Query.q': tumListe,
      searchcaribas(val) {
        val && this.carigetir(val)
      },
      searchcaribit(val) {
        val && this.carigetir2(val)
      },
      searchcariana(val) {
        val && this.carigetir3(val)
      },
    },

      beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {



      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }
    },
    methods: {
       clearSearch(){
this.Query.q='';
      },
      KartGorunumu(){
this.ListView=false;
this.CardView=true;

      },
      ListeGorunumu(){
this.ListView=true;
this.CardView=false;
this.getOtels('');
      },
      goDetail(val){
        const url = '#/coper/saticilar/goster/id?kod='+ escape(val.Kod)+'&tip='+ val.SaticiTipi;
        window.open(url,"_blank");
      },
      saticiExcel() {
        this.denemestatus = true
        var prm = {
          SaticiTipi: 3,
        }

        tool.api_post_FileDownload(this, "Coper/ExcelSaticiList", prm).then(

          response => {
            var blob = new Blob([response.data], {
              type: 'application/xlsx'
            });

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "RestaurantList.xlsx";
            link.click();
            this.denemestatus = false


          },

          response => {
            this.denemestatus = false

          }

        );
      },
      filtreiptal() {
        this.Current.Filters.BaslangicCari = null
        this.Current.Filters.BitisCari = null
        this.Current.Filters.AnaHeseap = null
        this.Current.Filters.AnalizKodu = null
        this.Current.Filters.Masraf = null
        this.Current.Filters.HesapGrubu = []
        this.Current.Filters.CariTip = '0' //0:hepsi, 1 : bireysel, 2 : Kurumsal
        this.Current.Filters.HesapGrupBos = false
        this.Current.Filters.MuhKodBos = false
        this.Current.Filters.DisAktarimBos = false
        this.Current.Filters.MasrafMerkeziTanimli = false
        this.tumsirketler = false
        this.dialogfiltre = false
      },
      filtrele() {
        this.dialogfiltre = true;
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesapgurubu = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

        this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.masrafmerkezi = response.body
        }, (response) => {
          if (response.status === 0) {

          } else {

          }
        })

        this.$http.post(auth.API_URL + 'api/Analysis/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.analiz = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })


      },
      efaturaSorgula() {
        var prm = {};

        this.denemestatus = true;
        tool.api_post(this, "EFatura/VKN_SorgulaTumu", prm).then(

          response => {
            this.denemestatus = false;
            this.text1 = response.body + ' adet cari hesap için E-Fatura sorgulama işlemi yapılmıştır.';
            this.snackbar = true;
          },
          response => {
            this.denemestatus = false;
          }
        );
      },
      getOtels: getOtels,
      //  getOtels2: getOtels2,

      carigetir: carigetir,
      carigetir2: carigetir2,
      carigetir3: carigetir3,
      tumListe: tumListe
    }
  }

  function carigetir(v) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (v.length >= 0) {
      this.loadingcaribas = true
      var params = {
        q: escape(v),
        c: credentials.SirketKodu
      }
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/itemsOtelearch',
          params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
          this.statecaribas = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-itemsOtelearch'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-itemsOtelearch'
            this.snackbar = true
          }
        })
        this.loadingcaribas = false
      }, 500)
    } else {
      this.statecaribas = []
    }
  }

  function carigetir2(v) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (v.length >= 0) {
      this.loadingcaribit = true
      var params = {
        q: escape(v),
        c: credentials.SirketKodu
      }
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/itemsOtelearch',
          params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
          this.statecaribit = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-itemsOtelearch'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-itemsOtelearch'
            this.snackbar = true
          }
        })
        this.loadingcaribit = false
      }, 500)
    } else {
      this.statecaribit = []
    }
  }

  function carigetir3(v) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (v.length >= 0) {
      this.loadingcariana = true
      var params = {
        q: escape(v),
        c: credentials.SirketKodu
      }
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/itemsOtelearch',
          params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
          this.statecariana = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-itemsOtelearch'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-itemsOtelearch'
            this.snackbar = true
          }
        })
        this.loadingcariana = false
      }, 500)
    } else {
      this.statecariana = []
    }
  }

  function getOtels(e) {

    this.dialogfiltre = false
    this.kayitvarmi = false
    if (e.length >= 3) {
      this.progress = true
      this.progress1 = false

      this.Otel.saticiTipi = 3
      this.Otel.saticiKodu = null
      this.Otel.sqlLike = e
      this.Otel.limit = 100

      var prm = this.Otel

      tool.http_post(this, "SaticiList", prm).then(
        response => {

          if (response.body.Status == true) {

            if (response.body.SaticiList.length > 0) {
              this.itemsOtel = response.body.SaticiList
              this.toplamkayit = this.$t('Total') + ':' + response.body.SaticiList.length + this.$t('number-records-listed')
              this.kayitvarmi = true
            } else {
              this.itemsOtel = []
              this.kayitvarmi = false
              this.toplamkayit = this.$t('No-Records-Found')
            }
            this.kayit = false
            this.kayitlar = true
            this.progress = false
            this.progress1 = true

          } else {
            this.progress = false
            this.itemsOtel = []
            this.progress1 = true
            this.kayitvarmi = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        },
        response => {
          this.progress = false
          this.itemsOtel = []
          this.progress1 = true
          this.kayitvarmi = false
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      );

    } else if (e.length === 0) {
      this.kayit = true
      this.kayitlar = false
      this.toplamkayit = 'Kayıt Yok'

      this.progress = false
      this.itemsOtel = []
    } else {
      this.text1 = 'Service Unavailable'
      this.kayitlar = false
      this.toplamkayit = 'Kayıt Yok'
      this.progress = false
      this.itemsOtel = []
    }
  }

  function tumListe(e) {
    this.kayitvarmi = false
    if (e.length >= 3) {
      var findStr = '%' + e + '%'
      this.Current.Code = findStr
      this.progress = true

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler == true) {
        this.Current.CompanyCode = 0
      } else {
        this.Current.CompanyCode = credentials.SirketKodu
      }

      var params = this.Current
      this.$http.post(auth.API_URL + 'api/Current/List', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.itemsOtel = response.body
        this.toplamkayit = this.$t('Total') + ':' + response.body.length + this.$t('number-records-listed')

        if (response.body.length > 0) {
          this.kayitvarmi = true
        } else {
          this.kayitvarmi = false
          this.toplamkayit = this.$t('No-Records-Found')
        }
        this.kayit = false
        this.kayitlar = true
        this.progress = false
        this.progress1 = true




      }, (response) => {
        if (response.status === 0) {
          this.progress = false

        } else {
          this.progress = false

        }
      })
      this.dialogfiltre = false
    }
  }
</script>

<style>

</style>